import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'bank',
                () => import('./bank/bank.module').then(m => m.BankModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'branch',
                () => import('./branch/branch.module').then(m => m.BranchModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'trackingbankaccountdata',
                () => import('./tracking-bank-account-data/tracking-bank-account-data.module').then(m => m.TrackingBankAccountDataModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
